import disableInboxRuleRequest from 'owa-service/lib/factory/disableInboxRuleRequest';
import disableInboxRuleOperation from 'owa-service/lib/operation/disableInboxRuleOperation';
import { getJsonRequestHeader } from 'owa-service/lib/ServiceRequestUtils';
/**
 * Helper method that creates the DisableInboxRuleRequest body
 * @param inboxRule the inbox rule
 * @return DisableInboxRuleRequest
 */
function createRequestBody(inboxRule, force, alwaysDeleteOutlookRulesBlob) {
    var requestBody = disableInboxRuleRequest({
        Header: getJsonRequestHeader(),
        Identity: inboxRule.Identity,
    });
    requestBody.Force = force;
    requestBody.AlwaysDeleteOutlookRulesBlob = alwaysDeleteOutlookRulesBlob;
    return requestBody;
}
/**
 * Disable inbox rule service
 * @param inboxRule the inbox rule
 * @return DisableInboxRuleResponse
 */
export default function disableInboxRuleService(inboxRule, force, alwaysDeleteOutlookRulesBlob) {
    var requestBody = createRequestBody(inboxRule, force, alwaysDeleteOutlookRulesBlob);
    return disableInboxRuleOperation(requestBody);
}
//# sourceMappingURL=disableInboxRuleService.js.map